import axios from "axios";

const FILE_UPLOAD_URL =
  process.env.NEXT_PUBLIC_S3_FILE_UPLOAD_URL ||
  "https://7mdmj295c9.execute-api.ap-south-1.amazonaws.com/beta/file-upload";

export const uploadToS3 = async (file, options) => {

  console.log('process.env.NEXT_PUBLIC_S3_FILE_UPLOAD_URL', process.env.NEXT_PUBLIC_S3_FILE_UPLOAD_URL);

  if (!FILE_UPLOAD_URL) {
    throw new Error("Please specify valid url");
  }
  if (!file) {
    throw new Error("Please specify valid image file");
  }
  const response = await axios.post(FILE_UPLOAD_URL, options);
  const uploadInfo = response.data?.data;
  const form = new FormData();
  Object.keys(uploadInfo.fields).forEach((key) =>
    form.append(key, uploadInfo.fields[key])
  );
  form.append("file", file);
  await axios.post(uploadInfo.url, form);
  return {
    url: `${form.get("Key")}`
  };
};

export const upload = async (file, options) => {
  const data = await uploadToS3(file, options);
  return data;
};

/*
const beforeImagePromise = upload(beforeImage, {
      // businessType: "skinnsi",
      // mobile: 9930023473, //#TO_DO handle otherwise
      mimeType: beforeImage.type,
      purpose: "chatAppUploads",
      objectKey: "/${chatId}_${userId}/${shortUUID()}" + objectKey,
    });
*/

export const checkImageSize = async (imageFile, reqImageSize) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(imageFile);
    try {
      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target?.result;
        image.onload = () => {
          const width = image.naturalWidth;
          const height = image.naturalHeight;
          console.log(`Width ${width} Height ${height}`);
          if (width * height >= reqImageSize) {
            resolve(true);
          } else {
            reject({
              message: `Height, Width less than min. required dimensions of (2560×1440)`,
              sizeError: true
            });
          }
        };
      };
    } catch (e) {
      console.log(e);
      reject();
    }
  });
};
